import { ErrorType } from '../types/index.js';
import { ConcreteException } from '../base.js';
import { mapErrorMessage } from '../utils/maps.js';
const removeTrustWalletFromErrorString = (message) => message
    .replaceAll('Trust Wallet', '')
    .replaceAll('TrustWallet', '')
    .replaceAll('Trustwallet', '')
    .replaceAll('TrustWallet:', '')
    .replaceAll('Trust Wallet:', '');
export class TrustWalletException extends ConcreteException {
    static errorClass = 'TrustWalletException';
    constructor(error, context) {
        super(error, context);
        this.type = ErrorType.WalletError;
    }
    parse() {
        const { message } = this;
        if (message
            .trim()
            .toLowerCase()
            .includes('missing or invalid parameters'.toLowerCase())) {
            this.setMessage('Please make sure you are using TrustWallet');
        }
        else {
            this.setMessage(mapErrorMessage(removeTrustWalletFromErrorString(message)));
        }
        this.setName(TrustWalletException.errorClass);
    }
}
